var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiFidUnlimited = function SvgMultiFidUnlimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.913,
    height: 13.833,
    fill: "#D7B97C",
    rx: 1,
    transform: "matrix(.96276 -.27035 .2843 .95874 4.001 9.613)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.674 13.805c1.433 2.64 1.149 3.907 1.058 4.486.389-.987.794-3.072-.183-4.87-1.278-2.355-1.326-3.505-1.138-4.337-.854 2.278-.236 3.802.263 4.721",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.949,
    height: 13.805,
    x: 10.001,
    y: 13.613,
    fill: "#000",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.11 20.716c.624 2.923-.01 4.065-.261 4.596.654-.843 1.637-2.737 1.211-4.728-.557-2.609-.276-3.726.142-4.475-1.47 1.958-1.31 3.59-1.092 4.607",
    clipRule: "evenodd"
  })));
};
export default SvgMultiFidUnlimited;